import { useQueryClient } from '@tanstack/react-query';

import { NETWORK_ELEMENTS } from '@constants/queryKeys';

const useInvalidateNetworkElements = () => {
	const queryClient = useQueryClient();

	const invalidateNetworkElements = () => {
		return [
			queryClient.invalidateQueries([NETWORK_ELEMENTS]),
		];
	};

	return invalidateNetworkElements;
};

export default useInvalidateNetworkElements;
